module.exports = __webpack_public_path__ + "static/chicory-dog-6800010ca49d731abb4fa5bf4f33fb43.png";